module.exports = __webpack_public_path__ + "img/Support-skill-402.0d10bfbe.png";